import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const CARDS = [
  ["brands", "Brands", "/admin/brands"], ["featured", "Featured on homepage", "/admin/brands?filter=featured"], ["new", "Marked as new", "/admin/brands?filter=new"],
  ["with_pdf", "Brands with a PDF", "/admin/brands"], ["categories", "Categories", "/admin/categories"], ["promotions", "Active promotions", "/admin/promotions"],
  ["new_enquiries", "New enquiries", "/admin/enquiries"], ["enquiries", "Total enquiries", "/admin/enquiries"],
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  return (
    <div data-testid="admin-dashboard">
      <p className="eyebrow text-[var(--terracotta)]">Overview</p>
      <h1 className="font-display text-4xl mt-2 text-[var(--ink)]">Good day. Here's the state of the range.</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
        {CARDS.map(([k, label, to]) => (
          <Link to={to} key={k} className="bg-white border border-[var(--sand)] rounded-lg p-6 hover:border-[var(--ink)] transition-colors" data-testid={`stat-${k}`}>
            <p className="font-display text-4xl text-[var(--ink)]">{stats ? stats[k] : "–"}</p>
            <p className="text-sm text-[var(--muted)] mt-1">{label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-12 grid md:grid-cols-3 gap-4">
        {[["Add a new brand", "Upload the logo, hero image and PDF; pick categories; mark it new.", "/admin/brands?new=1"], ["Run a promotion", "Feature a brand or seasonal range on the homepage.", "/admin/promotions"], ["Update the homepage", "Change the hero headline, spotlight brand, stats and retailer logos.", "/admin/homepage"]].map(([t, d, to]) => (
          <Link key={t} to={to} className="bg-[var(--ink)] text-[var(--cream)] rounded-lg p-6 hover:bg-[var(--terracotta)] transition-colors" data-testid={`quick-${t.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="font-display text-2xl">{t}</p><p className="text-sm text-[var(--stone)] mt-2">{d}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
